// src/utils/pointsCalculator.js
export const calculatePointsFromRating = (stars) => {
  return stars;
};

export const getBadgeForPoints = (points) => {
  if (points >= 1000000) return "Legendary Steward";
  if (points >= 100000) return "Guardian";
  if (points >= 1000) return "Harvester";
  if (points >= 100) return "Cultivator";
  if (points >= 1) return "Sprout";
  return "Seedling";
};
